import { ISubsidy } from '../../../interfaces/Subsidy.interfaces';
import { customAxios } from '../../common/customAxios';

interface IPatchSubsidyByIdParams {
  subsidyId: string;
  reqBody: Partial<ISubsidy>;
}

export const patchSubsidyById = ({ subsidyId, reqBody }: IPatchSubsidyByIdParams): Promise<ISubsidy> => {
  return customAxios.patch(`/subsidies/${subsidyId}`, reqBody);
};
